import { Sidebar, useUIContext } from '@sib/ui';
import { useSidebarItems } from './SidecarSidebar.utils';

interface SidecarSidebarProps {}

export const SidecarSidebar = (props: SidecarSidebarProps) => {
  const sidebarItems = useSidebarItems();
  const { sidebarOpen, setSidebarOpen } = useUIContext();

  return (
    <Sidebar
      open={sidebarOpen}
      onChange={setSidebarOpen}
      items={sidebarItems}
      applicationName={__APP_DISPLAY_NAME__}
      applicationVersion={__APP_VERSION__}
      {...props}
    />
  );
};
